module.exports = __webpack_public_path__ + "img/supertrebol.25f6b336.png";